import styled, { keyframes } from 'styled-components';

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(500px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 10;

  .active {
    opacity: 1;
    visibility: visible;
    right: 0px;
    animation: ${appearFromLeft} 0.5s;

    /* @media (max-width: 650px) {
      top: 0px;
      animation: ${appearFromTop} 0.5s;
    } */
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }

  div[title]:hover:after {
    opacity: 1;
    transition: all 0.1s ease 0.5s;
    visibility: visible;
  }
  div[title]:after {
    transition: all 0.1s ease 0.5s;
    content: attr(title);
    position: absolute;
    top: -100%;
    left: 0;
  }
`;

export const Content = styled.div`
  background: #fff;
  position: fixed;
  right: -450px;
  width: 700px;
  height: 100%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  visibility: hidden;
  opacity: 0;
  border-radius: 3px;
  padding: 0 10px;
  transition: all 0.5s ease-out;
	font-weight: 500;
	
  h2 {
    margin-left: 10px;
    color: #455a64;
  }

  @media (max-width: 850px) {
    right: 0px;
    // top: 800px;
    width: 100%;
    margin-top: 0px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  padding: 10px 0;
  width: 100%;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--azul-razio);
    font-weight: 500;

    svg {
      font-size: 20px;
      margin-right: 5px;
    }
  }
`;

export const OrderContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 5px 0
	 50px;
  margin-top: 45px;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;

  hr {
    background-color: #cfd8dc;
    border: none;
    width: 100%;
    height: 1px;
    margin: 10px 0 10px 0;
  }

  @media (max-width: 880px) {
    margin-top: 35px;
  }
`;

export const Venda = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px 0;

  .title-venda {
    display: flex;
    align-items: center;

    svg {
      font-size: 22px;
      margin-left: 10px;
    }
  }

  span {
    color: #333;
  }
`;

export const Entrega = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  .entrega-atraso {
    display: flex;
    align-items: center;

    svg {
      font-size: 22px;
      margin-left: 5px;
    }
  }

  span {
    color: #333;
  }
`;

export const Cliente = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Entregador = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Obs = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Valores = styled.div`
  .content-valores {
    margin-left: 10px;

    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .item-valores {
      span {
        color: #455a64;
      }
    }

    .total-valores {
      span {
        font-weight: 600;
        color: #333;
      }
    }
  }

  @media (max-width: 880px) {
    margin-bottom: 110px;
  }
`;
